import { MatxLoadable } from "matx";

const PersonalDaysHome = MatxLoadable({
  loader: () => import("./PersonalDaysHome"),
});

const FormRequestDay = MatxLoadable({
  loader: () => import("./FormRequestDay"),
});

const personalDaysRoutes = [
  {
    path: "/PersonalDays",
    component: PersonalDaysHome,
  },
  {
    path: "/FormRequestDay/:id",
    component: FormRequestDay,
  },
  {
    path: "/FormRequestDay",
    component: FormRequestDay,
  }
];

export default personalDaysRoutes;